










































import { Component, Vue } from 'vue-property-decorator'
import { getTitleList,getSmallProgramList } from '@/api/competition'
import {
  getBusinessData,
  getDataOverView, //营业数据
  getOrderData, //订单管理今日订单
  getOverviewDishes, //菜品总览
  getSetMealStatistics, //套餐总览
} from '@/api/index'
import { getOrderListBy } from '@/api/order'
// 组件
// 营业数据
import Overview from './components/overview.vue'
// 订单管理
// import Orderview from './components/orderview.vue'
// // 菜品总览
// import CuisineStatistics from './components/cuisineStatistics.vue'
// // 套餐总览
// import SetMealStatistics from './components/setMealStatistics.vue'
// 订单列表
import OrderList from './components/orderList.vue'
@Component({
  name: 'Dashboard',
  components: {
    Overview,
    // Orderview,
    // CuisineStatistics,
    // SetMealStatistics,
    OrderList,
  },
})
export default class extends Vue {
  private todayData = {} as any
  private overviewData = {}
  private orderviewData = {} as any
  private flag = 2
  private tateData = []
  private dishesData = {} as any
  private setMealData = {}
  private orderListData = []
  private titleId = ''
  private options =  []
  private smallProgramId = ''
  private smallProgram = []
  private counts = 0
  private page: number = 1
  private pageSize: number = 10
  private status = 2
  private orderData = []
  private orderStatics = {} as any
  created() {
    this.init()
  }
  async init() {
    if (this.options.length === 0){
      const pageParams = {
        page: this.page,
        pageSize: this.pageSize,
        type: 0,
      }
      await getTitleList(pageParams)
        .then((res: any) => {
          if (String(res.data.code) === '1') {
            this.options = res.data && res.data.data && res.data.data.records
            // this.titleId = res.data.data.records[0].id
            // this.counts = res.data.data.total
          }
          // if (!res.data.data.records.length && type === 'search') {
          //   this.$message.error('未搜索到相关员工，请核对员工姓名是否正确')
          // }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
      }
      if (this.smallProgram.length === 0){
      const pagesParams = {
        page: this.page,
        pageSize: this.pageSize,
        type: 0,
      }
    await getSmallProgramList(pagesParams)
      .then((res: any) => {
        if (String(res.data.code) === '1') {
          this.smallProgram = res.data && res.data.data && res.data.data.records
          // this.titleId = res.data.data.records[0].id
          // this.counts = res.data.data.total
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
    }

    this.$nextTick(() => {
      this.getBusinessData()
      this.getOrderListData()
      // this.getOrderStatisticsData()
      // this.getOverStatisticsData()
      // this.getSetMealStatisticsData()
    })
  }

  // 监听 titleId 的变化
  private handleTitleChange() {
    this.init();
  }
  // 获取营业数据
  async getBusinessData() {
    const data = await getBusinessData({titleId: this.titleId,smallProgramId: this.smallProgramId})
    this.overviewData = data.data.data
  }

  // // 获取订单数据
  async getOrderListData(status) {
    const params = {
      page: this.page,
      pageSize: this.pageSize,
      status: status,
    }
    const data = await getOrderListBy({titleId: this.titleId,smallProgramId: this.smallProgramId})
    this.orderData = data.data.data.orders
    // this.counts = data.data.data.total
    // if (
    //   this.dialogOrderStatus === 2 &&
    //   this.status === 2 &&
    //   this.isAutoNext &&
    //   !this.isTableOperateBtn &&
    //   data.data.records.length > 1
    // ) {
    //   const row = data.data.records[0]
    //   this.goDetail(row.id, row.status, row, row)
    // } else {
    //   return null
    // }
  }
  // 获取今日订单
  // async getOrderStatisticsData() {
  //   const data = await getOrderData()
  //   this.orderviewData = data.data.data
  // }
  // 获取菜品总览数据
  // async getOverStatisticsData() {
  //   const data = await getOverviewDishes()
  //   this.dishesData = data.data.data
  // }
  // 获取套餐总览数据
  // async getSetMealStatisticsData() {
  //   const data = await getSetMealStatistics()
  //   this.setMealData = data.data.data
  // }
  //获取待处理，待派送，派送中数量
  // getOrderListBy3Status() {
  //   getOrderListBy({})
  //     .then((res) => {
  //       if (res.data.code === 1) {
  //         this.orderStatics = res.data.data
  //       } else {
  //         this.$message.error(res.data.msg)
  //       }
  //     })
  //     .catch((err) => {
  //       this.$message.error('请求出错了：' + err.message)
  //     })
  // }
}
